var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'tg-logo': !_vm.isLogin, 'to-login-logo': _vm.isLogin },attrs:{"src":`/logo/${_vm.site}.png`,"alt":_vm.site}})
}
var staticRenderFns = []

export { render, staticRenderFns }